import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Result } from '@team23/ts-result';
import { IconStatus } from '@ui/shared/util-api';

type IconResult = Result<string, IconStatus>;

/**
 * Provides svg category icons for map items, each wrapped in a {@link Result}.
 * The icons are delivered in string format and contain svg content to be displayed in a component.
 */
@Injectable()
export abstract class AbstractMapIconsService {

    /**
     * All category icons currently loaded in the service.
     */
    public abstract mapIcons$: Observable<Map<string, IconResult>>;

    /**
     * The specific category icon for an iconPath. Should return content even when no icon exists for the path.
     */
    public abstract mapIcon$(iconPath: string): Observable<IconResult>;

    /**
     * Pass icon paths to the service, which the service should use to fetch svg data to provide.
     * This should be run whenever new map items are loaded, so their icons are always available.
     *
     * @param iconPaths An array of paths to svg files in the backend.
     * @param options Set `replaceExisting: true` to add even paths that already exist, forcing a re-fetch.
     */
    public abstract addIconsFromPaths(iconPaths: Array<string>, options?: { replaceExisting?: boolean }): void;

    /**
     * Clear all previously loaded icons from the service.
     */
    public abstract resetIcons(): void;

}
